import api, { authService } from './api';

export const ticketTypesService = {
  listTicketTypeOptions: async ({ limit = 5000 } = {}) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get('/ticket-types/options', {
        params: { limit },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        items: response.data.items || [],
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch ticket type options',
      };
    }
  },

  listTicketTypes: async ({ q, limit = 1000 } = {}) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get('/ticket-types', {
        params: { q, limit },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        items: response.data.items || [],
        totalCount: response.data.total_count || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch ticket types',
      };
    }
  },

  createTicketType: async (payload) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post('/ticket-types', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to create ticket type',
      };
    }
  },

  listAliases: async (ticketTypeId) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get(`/ticket-types/${encodeURIComponent(ticketTypeId)}/aliases`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        items: response.data.items || [],
        totalCount: response.data.total_count || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch ticket type aliases',
      };
    }
  },

  mergeTicketType: async (sourceTicketTypeId, targetTicketTypeId) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post(`/ticket-types/${encodeURIComponent(sourceTicketTypeId)}/merge`, {
        target_ticket_type_id: targetTicketTypeId,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        mergedTicketTypeId: response.data.merged_ticket_type_id,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to merge ticket type',
      };
    }
  },

  addAlias: async (ticketTypeId, aliasName, source = 'manual', tikwizOrderId = null) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post(`/ticket-types/${encodeURIComponent(ticketTypeId)}/aliases`, {
        alias_name: aliasName,
        source,
        ...(tikwizOrderId ? { tikwiz_order_id: tikwizOrderId } : {}),
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        message: response.data.message,
        orderUpdated: response.data.order_updated || false,
        tikwizOrderId: response.data.tikwiz_order_id || null,
        canonicalName: response.data.canonical_name || null,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to add ticket type alias',
      };
    }
  },
};
